import PrematchService from '@/services/PrematchService'

const state = () => ({
  menu: [],
  popular: {
    menu: [],
    leagues: [],
    sports: []
  },
  sport: {},
  groups: {},
  leagues: [],
  timeFilterValue: 0,
  loader: {
    top: true,
    loading: 0,
    scrollLoading: 0
  },
  screen: {
    top: 0,
    bottom: 0
  },
  eventview: {
    sport: {},
    league: {},
    event: {},
    periods: {}
  }
})

const getters = {
  OVERVIEW_GROUP: state => sport => {
    return state.groups[sport.toString()] ? state.groups[sport.toString()] : 1
  }
}

const actions = {
  async GET_MENU_SPORTS ({ commit, state }) {
    try {
      const response = await PrematchService.list(Object.assign({
        hours: state.timeFilterValue
      }))
      commit('SET_MENU_SPORTS', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_MATCHES ({ commit, state }, { params, scroll = false }) {
    commit('INC' + (scroll ? '_SCROLL' : '') + '_LOADING')
    try {
      const response = await PrematchService.matches(Object.assign({
        hours: state.timeFilterValue
      }, params))
      commit('SET_MATCHES', response.data)
      commit('DEC' + (scroll ? '_SCROLL' : '') + '_LOADING')
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_POPULAR_MATCHES ({ commit, state }, { params, scroll = false }) {
    commit('INC' + (scroll ? '_SCROLL' : '') + '_LOADING')
    try {
      const response = await PrematchService.popular(params)
      commit('SET_POPULAR_MATCHES', response.data)
      commit('DEC' + (scroll ? '_SCROLL' : '') + '_LOADING')
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_EVENT ({ commit }, event) {
    try {
      const response = await PrematchService.event(event)
      commit('SET_EVENT', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  SET_MENU_SPORTS (state, data) {
    state.menu = data.sports.map(sport => { return Object.assign({}, sport) })
    state.popular.menu = data.popular.sports.map(sport => { return Object.assign({}, sport) })
    state.popular.leagues = data.popular.leagues.map(league => { return Object.assign({}, league) })
  },
  SET_MATCHES (state, data) {
    state.sport = Object.assign({}, data.sport)
    state.leagues = data.leagues.map(league => { return Object.assign({}, league) })
    state.screen = Object.assign({}, data.screen)
  },
  SET_POPULAR_MATCHES (state, data) {
    state.popular.sports = data.sports.map(sport => { return Object.assign({}, sport) })
    state.screen = Object.assign({}, data.screen)
  },
  SET_OVERVIEW_GROUP (state, { sport, group }) {
    state.groups[sport.toString()] = group
    state.groups = Object.assign({}, state.groups)
  },
  SET_TIME_FILTER_VALUE (state, hours) {
    state.timeFilterValue = hours
  },
  CLEAR_LOADING (state) {
    state.loader.loading = 0
    state.loader.scrollLoading = 0
  },
  INC_LOADING (state) {
    state.loader.loading++
  },
  DEC_LOADING (state) {
    state.loader.loading--
  },
  INC_SCROLL_LOADING (state) {
    state.loader.scrollLoading++
  },
  DEC_SCROLL_LOADING (state) {
    state.loader.scrollLoading--
  },
  SET_LOADER_POSITION (state, position) {
    state.loader.top = position !== 'bottom'
  },

  SET_EVENT (state, data) {
    state.eventview.sport = Object.assign({}, data.sport)
    state.eventview.league = Object.assign({}, data.league)
    state.eventview.event = Object.assign({}, data.event)
    state.eventview.periods = data.periods.map(period => { return Object.assign({}, period) })
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/prematch.js